import React from 'react'
import filePdf from '../../../../Assets/Images/file.pdf';
import "./Main.css";

 export default function Main() {
  return (
    <main className='main'>
        <div className="container">
            <h2 className="main-title">Be Natural Organics</h2>
            <h3 className="main-subtitle">
            foods & cereals
            </h3>
            <div className='main-blok'>
                <hr />
            <span className="main-text">
            We create brands. We create quality
            </span>
            <hr />
            </div>
            <div className="main-box">
                <a href="#" className="main-contact">
                    Contact us
                </a>
                <a href={filePdf} download className="main-download">Download Brochure</a>
            </div>
        </div>

    </main>
  )
}
